import { isValidDateFormat } from '@Helpers';
import { normalizeUKPhoneNumber, validateUKPhoneNumber } from '@Helpers';
import {
    getFirstAddressHistoryError,
    hasAddressHistoryErrors,
    validateAddressHistory,
} from '@selina-finance/ui';
import { format } from 'date-fns';
import * as Yup from 'yup';

import {
    months,
    parseValidDate,
    toApiDate,
    toValidDate,
    years,
} from '@Shared/helpers/date';

const firstNameError = 'Please enter a valid first name';
const lastNameError = 'Please enter a valid surname';
export const requiredErrorMessage = 'This is a required field';

export enum NationalityEnum {
    AFGHANISTAN = 'Afghanistan',
    ALAND_ISLANDS = 'Aland Islands',
    ALBANIA = 'Albania',
    ALGERIA = 'Algeria',
    ANDORRA = 'Andorra',
    ANGOLA = 'Angola',
    ANGUILLA = 'Anguilla',
    ANTARCTICA = 'Antarctica',
    ANTIGUA_AND_BARBUDA = 'Antigua and Barbuda',
    ARGENTINA = 'Argentina',
    ARMENIA = 'Armenia',
    ARUBA = 'Aruba',
    AUSTRALIA = 'Australia',
    AUSTRIA = 'Austria',
    AZERBAIJAN = 'Azerbaijan',
    BAHAMAS = 'Bahamas',
    BAHRAIN = 'Bahrain',
    BANGLADESH = 'Bangladesh',
    BARBADOS = 'Barbados',
    BELARUS = 'Belarus',
    BELGIUM = 'Belgium',
    BELIZE = 'Belize',
    BENIN = 'Benin',
    BERMUDA = 'Bermuda',
    BHUTAN = 'Bhutan',
    BOLIVIA_PLURINATIONAL_STATE_OF = 'Bolivia, Plurinational State of',
    BONAIRE_SINT_EUSTATIUS_AND_SABA = 'Bonaire, Sint Eustatius and Saba',
    BOSNIA_AND_HERZEGOVINA = 'Bosnia and Herzegovina',
    BOTSWANA = 'Botswana',
    BOUVET_ISLAND = 'Bouvet Island',
    BRAZIL = 'Brazil',
    BRITISH_INDIAN_OCEAN_TERRITORY = 'British Indian Ocean Territory',
    BRUNEI_DARUSSALAM = 'Brunei Darussalam',
    BULGARIA = 'Bulgaria',
    BURKINA_FASO = 'Burkina Faso',
    BURUNDI = 'Burundi',
    CAMBODIA = 'Cambodia',
    CAMEROON = 'Cameroon',
    CANADA = 'Canada',
    CAPE_VERDE = 'Cape Verde',
    CAYMAN_ISLANDS = 'Cayman Islands',
    CENTRAL_AFRICAN_REPUBLIC = 'Central African Republic',
    CHAD = 'Chad',
    CHILE = 'Chile',
    CHINA = 'China',
    CHRISTMAS_ISLAND = 'Christmas Island',
    COCOS_KEELING_ISLANDS = 'Cocos (Keeling) Islands',
    COLOMBIA = 'Colombia',
    COMOROS = 'Comoros',
    CONGO = 'Congo',
    CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE = 'Congo, the Democratic Republic of the',
    COOK_ISLANDS = 'Cook Islands',
    COSTA_RICA = 'Costa Rica',
    COTE_DIVOIRE = 'Cote d’Ivoire',
    CROATIA = 'Croatia',
    CUBA = 'Cuba',
    CURACAO = 'Curaçao',
    CYPRUS = 'Cyprus',
    CZECH_REPUBLIC = 'Czech Republic',
    DENMARK = 'Denmark',
    DJIBOUTI = 'Djibouti',
    DOMINICA = 'Dominica',
    DOMINICAN_REPUBLIC = 'Dominican Republic',
    ECUADOR = 'Ecuador',
    EGYPT = 'Egypt',
    EL_SALVADOR = 'El Salvador',
    EQUATORIAL_GUINEA = 'Equatorial Guinea',
    ERITREA = 'Eritrea',
    ESTONIA = 'Estonia',
    ETHIOPIA = 'Ethiopia',
    FALKLAND_ISLANDS_MALVINAS = 'Falkland Islands (Malvinas)',
    FAROE_ISLANDS = 'Faroe Islands',
    FIJI = 'Fiji',
    FINLAND = 'Finland',
    FRANCE = 'France',
    FRENCH_GUIANA = 'French Guiana',
    FRENCH_POLYNESIA = 'French Polynesia',
    FRENCH_SOUTHERN_TERRITORIES = 'French Southern Territories',
    GABON = 'Gabon',
    GAMBIA = 'Gambia',
    GEORGIA = 'Georgia',
    GERMANY = 'Germany',
    GHANA = 'Ghana',
    GIBRALTAR = 'Gibraltar',
    GREECE = 'Greece',
    GREENLAND = 'Greenland',
    GRENADA = 'Grenada',
    GUADELOUPE = 'Guadeloupe',
    GUATEMALA = 'Guatemala',
    GUERNSEY = 'Guernsey',
    GUINEA = 'Guinea',
    GUINEA_BISSAU = 'Guinea-Bissau',
    GUYANA = 'Guyana',
    HAITI = 'Haiti',
    HEARD_ISLAND_AND_MCDONALD_ISLANDS = 'Heard Island and McDonald Islands',
    HOLY_SEE_VATICAN_CITY_STATE = 'Holy See (Vatican City State)',
    HONDURAS = 'Honduras',
    HUNGARY = 'Hungary',
    ICELAND = 'Iceland',
    INDIA = 'India',
    INDONESIA = 'Indonesia',
    IRAN_ISLAMIC_REPUBLIC_OF = 'Iran, Islamic Republic of',
    IRAQ = 'Iraq',
    IRELAND = 'Ireland',
    ISLE_OF_MAN = 'Isle of Man',
    ISRAEL = 'Israel',
    ITALY = 'Italy',
    JAMAICA = 'Jamaica',
    JAPAN = 'Japan',
    JERSEY = 'Jersey',
    JORDAN = 'Jordan',
    KAZAKHSTAN = 'Kazakhstan',
    KENYA = 'Kenya',
    KIRIBATI = 'Kiribati',
    KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF = 'Korea, Democratic People’s Republic of',
    KOREA_REPUBLIC_OF = 'Korea, Republic of',
    KUWAIT = 'Kuwait',
    KYRGYZSTAN = 'Kyrgyzstan',
    LAO_PEOPLES_DEMOCRATIC_REPUBLIC = 'Lao People’s Democratic Republic',
    LATVIA = 'Latvia',
    LEBANON = 'Lebanon',
    LESOTHO = 'Lesotho',
    LIBERIA = 'Liberia',
    LIBYAN_ARAB_JAMAHIRIYA = 'Libyan Arab Jamahiriya',
    LIECHTENSTEIN = 'Liechtenstein',
    LITHUANIA = 'Lithuania',
    LUXEMBOURG = 'Luxembourg',
    MACAO = 'Macao',
    MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF = 'Macedonia, the former Yugoslav Republic of',
    MADAGASCAR = 'Madagascar',
    MALAWI = 'Malawi',
    MALAYSIA = 'Malaysia',
    MALDIVES = 'Maldives',
    MALI = 'Mali',
    MALTA = 'Malta',
    MARTINIQUE = 'Martinique',
    MAURITANIA = 'Mauritania',
    MAURITIUS = 'Mauritius',
    MAYOTTE = 'Mayotte',
    MEXICO = 'Mexico',
    MOLDOVA_REPUBLIC_OF = 'Moldova, Republic of',
    MONACO = 'Monaco',
    MONGOLIA = 'Mongolia',
    MONTENEGRO = 'Montenegro',
    MONTSERRAT = 'Montserrat',
    MOROCCO = 'Morocco',
    MOZAMBIQUE = 'Mozambique',
    MYANMAR = 'Myanmar',
    NAMIBIA = 'Namibia',
    NAURU = 'Nauru',
    NEPAL = 'Nepal',
    NETHERLANDS = 'Netherlands',
    NEW_CALEDONIA = 'New Caledonia',
    NEW_ZEALAND = 'New Zealand',
    NICARAGUA = 'Nicaragua',
    NIGER = 'Niger',
    NIGERIA = 'Nigeria',
    NIUE = 'Niue',
    NORFOLK_ISLAND = 'Norfolk Island',
    NORWAY = 'Norway',
    OMAN = 'Oman',
    PAKISTAN = 'Pakistan',
    PALESTINE = 'Palestine',
    PANAMA = 'Panama',
    PAPUA_NEW_GUINEA = 'Papua New Guinea',
    PARAGUAY = 'Paraguay',
    PERU = 'Peru',
    PHILIPPINES = 'Philippines',
    PITCAIRN = 'Pitcairn',
    POLAND = 'Poland',
    PORTUGAL = 'Portugal',
    QATAR = 'Qatar',
    REUNION = 'Reunion',
    ROMANIA = 'Romania',
    RUSSIAN_FEDERATION = 'Russian Federation',
    RWANDA = 'Rwanda',
    SAINT_BARTHELEMY = 'Saint Barthélemy',
    SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA = 'Saint Helena, Ascension and Tristan da Cunha',
    SAINT_KITTS_AND_NEVIS = 'Saint Kitts and Nevis',
    SAINT_LUCIA = 'Saint Lucia',
    SAINT_MARTIN_FRENCH_PART = 'Saint Martin (French part)',
    SAINT_PIERRE_AND_MIQUELON = 'Saint Pierre and Miquelon',
    SAINT_VINCENT_AND_THE_GRENADINES = 'Saint Vincent and the Grenadines',
    SAMOA = 'Samoa',
    SAN_MARINO = 'San Marino',
    SAO_TOME_AND_PRINCIPE = 'Sao Tome and Principe',
    SAUDI_ARABIA = 'Saudi Arabia',
    SENEGAL = 'Senegal',
    SERBIA = 'Serbia',
    SEYCHELLES = 'Seychelles',
    SIERRA_LEONE = 'Sierra Leone',
    SINGAPORE = 'Singapore',
    SINT_MAARTEN_DUTCH_PART = 'Sint Maarten (Dutch part)',
    SLOVAKIA = 'Slovakia',
    SLOVENIA = 'Slovenia',
    SOLOMON_ISLANDS = 'Solomon Islands',
    SOMALIA = 'Somalia',
    SOUTH_AFRICA = 'South Africa',
    SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS = 'South Georgia and the South Sandwich Islands',
    SOUTH_SUDAN = 'South Sudan',
    SPAIN = 'Spain',
    SRI_LANKA = 'Sri Lanka',
    SUDAN = 'Sudan',
    SURINAME = 'Suriname',
    SVALBARD_AND_JAN_MAYEN = 'Svalbard and Jan Mayen',
    SWAZILAND = 'Swaziland',
    SWEDEN = 'Sweden',
    SWITZERLAND = 'Switzerland',
    SYRIAN_ARAB_REPUBLIC = 'Syrian Arab Republic',
    TAIWAN = 'Taiwan',
    TAJIKISTAN = 'Tajikistan',
    TANZANIA_UNITED_REPUBLIC_OF = 'Tanzania, United Republic of',
    THAILAND = 'Thailand',
    TIMOR_LESTE = 'Timor-Leste',
    TOGO = 'Togo',
    TOKELAU = 'Tokelau',
    TONGA = 'Tonga',
    TRINIDAD_AND_TOBAGO = 'Trinidad and Tobago',
    TUNISIA = 'Tunisia',
    TURKEY = 'Turkey',
    TURKMENISTAN = 'Turkmenistan',
    TURKS_AND_CAICOS_ISLANDS = 'Turks and Caicos Islands',
    TUVALU = 'Tuvalu',
    UGANDA = 'Uganda',
    UKRAINE = 'Ukraine',
    UNITED_ARAB_EMIRATES = 'United Arab Emirates',
    UNITED_STATES = 'United States',
    UNKNOWN = 'Unknown',
    URUGUAY = 'Uruguay',
    UZBEKISTAN = 'Uzbekistan',
    VANUATU = 'Vanuatu',
    VENEZUELA_BOLIVARIAN_REPUBLIC_OF = 'Venezuela, Bolivarian Republic of',
    VIETNAM = 'Vietnam',
    VIRGIN_ISLANDS_BRITISH = 'Virgin Islands, British',
    WALLIS_AND_FUTUNA = 'Wallis and Futuna',
    WESTERN_SAHARA = 'Western Sahara',
    YEMEN = 'Yemen',
    ZAMBIA = 'Zambia',
    ZIMBABWE = 'Zimbabwe',
}

export const Nationalities = Object.values(NationalityEnum).map((country) => ({
    label: country,
    value: country,
}));

export const formItems = {
    // ----------------------------------------------------------------
    month: {
        items: months,
    },
    year: {
        items: years,
    },
    title: {
        items: [
            { label: 'Mr.', value: 'Mr.' },
            { label: 'Ms.', value: 'Ms.' },
            { label: 'Miss', value: 'Miss' },
            { label: 'Mrs.', value: 'Mrs.' },
            { label: 'Dr.', value: 'Dr.' },
            { label: 'Other', value: 'Other' },
        ],
        validation: Yup.string().nullable().required(requiredErrorMessage),
        transform: { target: 'title' },
        default: '',
    },
    // ----------------------------------------------------------------
    firstName: {
        validation: Yup.string()
            .nullable()
            .required(firstNameError)
            .min(2, firstNameError)
            .max(255, firstNameError),
        transform: { target: 'firstName' },
    },
    // ----------------------------------------------------------------
    middleName: {
        validation: Yup.string().nullable(),
        transform: { target: 'middleName' },
    },
    // ----------------------------------------------------------------
    lastName: {
        validation: Yup.string()
            .nullable()
            .required(lastNameError)
            .min(2, lastNameError)
            .max(255, lastNameError),
        transform: { target: 'lastName' },
    },
    // ----------------------------------------------------------------
    dateOfBirth: {
        validation: Yup.string()
            .required('Please specify your birth date')
            .test('valid_date', 'Invalid date', (dt: any) => {
                const isValidDate = isValidDateFormat(dt);
                let isValidInterval = true;
                if (isValidDate) {
                    const min = new Date(1900, 0, 1);
                    const max = new Date();
                    isValidInterval =
                        parseValidDate(dt) >= min && parseValidDate(dt) <= max;
                }
                return isValidDate && isValidInterval;
            }),
        transform: {
            target: 'dateOfBirth',
            toRequest: (value: string) => toApiDate(value),
            fromRequest: (value: string) => toValidDate(value),
        },
    },
    // ----------------------------------------------------------------
    kqUkResidency: {
        validation: Yup.boolean()
            .nullable()
            .required('This is a required field'),
        default: null,
        transform: {
            target: 'kqUkResidency',
            fromRequest: (value: boolean) => value?.toString(),
        },
    },
    nationality: {
        validation: Yup.string()
            .when('kqUkResidency', {
                is: false,
                then: Yup.string()
                    .nullable()
                    .required('Please specify your citizenship'),
            })
            .nullable(),
        transform: {
            target: 'nationality',
            toRequest: (value: string, dependencies: any) => {
                if (dependencies.isBritishCitizen === 'true') {
                    return 'United Kingdom';
                } else {
                    return value;
                }
            },
        },
    },
    // ----------------------------------------------------------------
    mobilePhoneNumber: {
        validation: Yup.string()
            .nullable()
            .test(
                'validPhoneNumber',
                'Please enter a valid UK mobile number',
                (value: any) => {
                    return validateUKPhoneNumber(value || '');
                },
            )
            .test(
                'uniquePhoneNumber',
                'This phone number must be different from the first applicants',
                (value, context) => {
                    const primary =
                        context?.parent?.primaryApplicantPhoneNumber;
                    if (!value || !primary) return true;
                    return (
                        normalizeUKPhoneNumber(value) !==
                        normalizeUKPhoneNumber(primary)
                    );
                },
            ),
        transform: {
            target: 'mobilePhoneNumber',
            toRequest: (value: string) =>
                value ? normalizeUKPhoneNumber(value) : value,
        },
    },
    // ----------------------------------------------------------------
    emailAddress: {
        validation: Yup.string()
            .email('Please enter a valid email address')
            .test(
                'uniqueEmailAddress',
                'Please enter an email address which is different from the first applicants',
                (value, context) =>
                    !!value && value !== context?.parent?.primaryApplicantEmail,
            ),
        transform: {
            target: 'emailAddress',
        },
    },
    // ----------------------------------------------------------------
    maritalStatus: {
        items: [
            { label: 'Civil partnership', value: 'Civil partnership' },
            { label: 'Divorced', value: 'Divorced' },
            { label: 'Married', value: 'Married' },
            { label: 'Separated', value: 'Separated' },
            { label: 'Single', value: 'Single' },
            { label: 'Widowed', value: 'Widowed' },
        ],
        validation: Yup.string().nullable().required(requiredErrorMessage),
        transform: { target: 'maritalStatus' },
        default: '',
    },
    // ----------------------------------------------------------------
    notHavePermanentRightToResideInTheUk: {
        validation: Yup.boolean()
            .when('kqUkResidency', {
                is: false,
                then: Yup.boolean().nullable().required(requiredErrorMessage),
            })
            .nullable(),
        default: null,
        transform: {
            target: 'notHavePermanentRightToResideInTheUk',
        },
    },
    // ----------------------------------------------------------------
    hasAnyCriminalConvictions: {
        validation: Yup.boolean().nullable().required(requiredErrorMessage),
        default: null,
        transform: {
            target: 'hasAnyCriminalConvictions',
        },
    },
    // ----------------------------------------------------------------
    hasSecondApplicant: {
        validation: Yup.boolean().nullable().required(requiredErrorMessage),
        default: null,
    },
    // ----------------------------------------------------------------
    addresses: {
        default: [
            {
                address: undefined,
                livedIn: {},
            },
        ],
        validation: Yup.array().test(
            'hasValidAddressHistory',
            function (value: any) {
                const errors = validateAddressHistory(value);

                if (!hasAddressHistoryErrors(errors)) {
                    return true;
                }

                return this.createError({
                    message:
                        getFirstAddressHistoryError(errors) ||
                        'Please enter at least 3 years of your address history',
                });
            },
        ),
        transform: {
            target: 'addresses',
            fromRequest: (_value: any, dependencies: any) => {
                return dependencies.addresses.map((address: any) => {
                    const from = address?.livedIn?.from;
                    const to = address?.livedIn?.to;
                    if (from) {
                        const isValidFromDate = isValidDateFormat(from);
                        const validFromDate = parseValidDate(from);
                        address.livedIn.from = isValidFromDate
                            ? format(validFromDate, 'MM/yyyy')
                            : '';
                    }
                    if (to) {
                        const isValidToDate = isValidDateFormat(to);
                        const validToDate = parseValidDate(to);
                        address.livedIn.to = isValidToDate
                            ? format(validToDate, 'MM/yyyy')
                            : '';
                    }
                    return address;
                });
            },
            toRequest: (_value: any, dependencies: any) => {
                return dependencies.addresses.map((address: any) => {
                    if (address?.livedIn?.from) {
                        address.livedIn.from = '01/' + address.livedIn.from;
                    }
                    if (address?.livedIn?.to) {
                        address.livedIn.to = '01/' + address.livedIn.to;
                    }
                    return address;
                });
            },
        },
    },
};
